import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { LogOut } from 'src/app/store/actions/auth.actions';

import { AppState, selectAuthState } from 'src/app/store/app.states';
import { StorageService } from 'src/app/services/common/storage';
import { getAuth, signOut } from 'firebase/auth';
import { FirebaseApp } from '@angular/fire/app';
import { SettingService } from 'src/app/services/setting/setting-service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

    public state: any;
    public isAdmin;
    public disableRegistration = false;
    public isAuthenticated: any = false;
    public classApplied: boolean = false;

    public imageSrc: string = 'assets/img/logo/eult.png'; // Image par défaut

    constructor(public setting: SettingService, public storage: StorageService, private afApp: FirebaseApp, private localStorage: StorageService, private router: Router, private store: Store<AppState>) {
    }


    @HostListener('window:scroll')
    onWindowScroll(): void {
        const isSticky = window.pageYOffset > 50; // Exemple de seuil de défilement
        this.imageSrc = isSticky
            ? 'assets/img/logo/eulob.jpeg' // Nouvelle image lorsque sticky
            : 'assets/img/logo/eult.png';   // Image par défaut
    }

    ngOnInit(): void {

        this.setting.settingRegistration().subscribe(x => {
            this.disableRegistration = x[0].disabled;
        })
        this.store.select(selectAuthState).subscribe((state) => {
            this.state = state;
            if (state) {
                this.isAuthenticated = state["user"].isAuthenticated;
                this.isAdmin = state["user"].isAdmin;
            }

        });
    }

    /**
     * Go to pre-registration users page
     */
    ask() {
        this.router.navigateByUrl("/students-registration")
    }



    toggleClass() {
        this.classApplied = !this.classApplied;
    }

    /**
    * Close menu
    */
    closeMenu() {

        if (this.classApplied) {
            this.classApplied = !this.classApplied;
        }
    }


    /**
    * Go to pre-registration users page
    */
    async logOut() {
        this.storage.clear();
        const test = await this.storage.getItem("isLevel2");
        localStorage.clear();
        const auth = getAuth(this.afApp);
        signOut(auth);
        this.store.dispatch(new LogOut(this.localStorage));
        //this.router.navigateByUrl("/");
    }

}